/* eslint-disable no-return-assign */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import KpiBreakdown from "components/KpiBreakdown";
import MDTypography from "components/MDTypography";
import moment from "moment";
import { generateColorFromString } from "utils/GenerateColorFromString/GenerateColorFromString";
import { generateDonutChartData } from "utils/PerformanceHelperFunctions";

function KpiBreakdownWidget({ selectedTab, selectedUser, selectedTeam }) {
  const loginUserState = useSelector((state) => state.loginUser.loginUserState);
  const [dataStructure, setDataStructure] = useState({
    labels: [],
    data: [],
    colors: [],
  });

  const { data: individualPerformance } = useSelector((state) => state.home.kpiEntries);

  const { data: teamMemberPerformance } = useSelector(
    (state) => state.manager.teamMemberPerformance
  );

  const setIndividualData = async () => {
    const data = { labels: [], data: [], colors: [] };
    individualPerformance.forEach((entry) => {
      if (Number(entry?.DailyActions?.[0]?.count)) {
        data.labels.push(entry?.KpiActivity?.name);
        data.data.push(Number(entry.DailyActions?.[0]?.count));
        data.colors.push(generateColorFromString(entry?.KpiActivity?.name));
      }
    });

    setDataStructure(data);
  };

  const setTeamData = async () => {
    const formattedData = [];
    teamMemberPerformance.forEach((dataObj) => {
      if (!selectedTeam || selectedTeam?.teamId === dataObj?.teamId) {
        dataObj?.users?.forEach((user) => {
          const obj = {
            userData: { id: user?.userId, name: user?.name },
            kpiActiontotal: [],
          };
          user?.kpiWisePerformance?.forEach((kpiData) => {
            const matchedDate = kpiData?.dateWisePoints?.find((dateWiseObj) =>
              moment(dateWiseObj?.createdDate).isSame(
                moment.tz(undefined, loginUserState.timezone),
                "day"
              )
            );

            if (matchedDate?.points || matchedDate?.count)
              obj?.kpiActiontotal?.push({
                kpiActionId: kpiData?.kpiActionId,
                kpiActionName: kpiData?.KpiActivity?.name,
                totalPoints: matchedDate?.points,
                totalCounts: matchedDate?.count,
                createdAt: moment(matchedDate?.createdDate).format("YYYY-MM-DD"),
              });
          });

          formattedData?.push(obj);
        });
      }
    });

    const structuredPieChartData = generateDonutChartData(formattedData, selectedUser || "all");
    const { labels, data, graphKpiColors } = structuredPieChartData.kpiBreakdown;
    setDataStructure({ labels, data, colors: graphKpiColors });
  };

  useEffect(() => {
    if (selectedTab === 0) {
      setIndividualData();
    }
  }, [individualPerformance]);

  useEffect(() => {
    if (selectedTab === 1) {
      setTeamData();
    }
  }, [selectedUser, teamMemberPerformance, selectedTeam]);

  return (
    <Box
      p={2}
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <MDTypography mb={1} variant="h6" textAlign="center" className="dragHandle" lineHeight="1rem">
        Completed KPI Breakdown
      </MDTypography>
      <KpiBreakdown graphData={dataStructure} />
    </Box>
  );
}

export default KpiBreakdownWidget;
